// get data from local json file called interfaceGraphMockData.json as jsonPayloadResponse
import jsonPayloadResponse from "./donutGraphMockData.json";
import {fetchBackupData, fetchPolicyData} from "../../../utils/dashboardCalls";

const mockDataRetriever = (setRawData, setLoading, _jobIds, _cid) => {
    const mockData = [];
    const rawData = Object.values(jsonPayloadResponse?.result ?? {});
    rawData.forEach(companyIdLinkedDataDict => mockData.push(...(companyIdLinkedDataDict?.data ?? [])));

    const second = 1000;
    const mockDelay = 0.5 * second;
    setLoading(true);
    const handle = setTimeout(() => {
        setRawData(mockData);
        setLoading(false);
    }, mockDelay);
};

const storagePoliciesDataRetriever = (setRawData, setLoading, jobIds, cid, options = {}) => {
    setLoading(true);
    fetchPolicyData(jobIds, cid, options)
        .then(data => {
            const resultsArray = [];
            const rawData = Object.values(data?.result ?? {});
            rawData.forEach(i => resultsArray.push(...(i?.data ?? [])));
            setRawData(resultsArray);
            setLoading(false);
        })
        .catch(error => {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') return;
            console.error("Error fetching storage policies data:", error);
            setRawData([]);
            setLoading(false);
        })
};

const backupDataRetriever = (setRawData, setLoading, jobIds, cid, options = {}) => {
    setLoading(true);
    fetchBackupData(jobIds, cid, options)
        .then(data => {
            const resultsArray = [];
            const rawData = Object.values(data?.result ?? {});
            rawData.forEach(i => resultsArray.push(...(i?.data ?? [])));
            setRawData(resultsArray);
            setLoading(false);
        })
        .catch(error => {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') return;
            console.error("Error fetching backup data:", error);
            setRawData([]);
            setLoading(false);
        })
};

export const variantDataRetrieverMapDonutGraph = {
    defValue: mockDataRetriever,
    backup: backupDataRetriever,
    storagePolicies: storagePoliciesDataRetriever,
};